var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-0",attrs:{"small":"","color":"black","fab":"","href":_vm.fullscreenViewerUrl}},[_c('fullScreenIcon',{class:[_vm.$style.buttonIconPosition, _vm.$style.iconImageStyle]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }